export default function Home() {
    return (
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h1 className="text-2xl font-bold mb-4">Welcome to Member Management</h1>
        <p className="text-gray-600">Use the navigation above to manage members.</p>
      </div>
    );
  }